var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnBtnTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICN_BTN_Translate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Components---Master",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICN_BTN_Translate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.578721, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3C3C3B",
    x: 8.9212785,
    y: 1,
    width: 1,
    height: 17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3C3C3B",
    strokeWidth: 2,
    cx: 9.4212785,
    cy: 9,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4339958,4.89749247 C17.5868319,5.19540181 17.723542,5.50294783 17.8429737,5.81897815 C15.3603433,6.57080285 12.4854861,7 9.4212785,7 C6.3568652,7 3.48182779,6.57074523 0.99899695,5.81961664 C1.11901502,5.50294783 1.25572512,5.19540181 1.40856117,4.89749247 C3.75789303,5.59401174 6.49121661,6 9.4212785,6 C12.3037718,6 14.9958628,5.60708693 17.3190388,4.93170368 Z",
    id: "Combined-Shape",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4339958,7.89749247 C20.5868319,8.19540181 20.723542,8.50294783 20.8429737,8.81897815 C18.3603433,9.57080285 15.4854861,10 12.4212785,10 C9.3568652,10 6.48182779,9.57074523 3.99899695,8.81961664 C4.11901502,8.50294783 4.25572512,8.19540181 4.40856117,7.89749247 C6.75789303,8.59401174 9.49121661,9 12.4212785,9 C15.3037718,9 17.9958628,8.60708693 20.3190388,7.93170368 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#3C3C3B",
    transform: "translate(12.421487, 8.948421) rotate(-90.000000) translate(-12.421487, -8.948421) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4339958,7.89749247 C14.5868319,8.19540181 14.723542,8.50294783 14.8429737,8.81897815 C12.3603433,9.57080285 9.48548612,10 6.4212785,10 C3.3568652,10 0.481827794,9.57074523 -2.00100305,8.81961664 C-1.88098498,8.50294783 -1.74427488,8.19540181 -1.59143883,7.89749247 C0.757893031,8.59401174 3.49121661,9 6.4212785,9 C9.30377175,9 11.9958628,8.60708693 14.3190388,7.93170368 Z",
    id: "Combined-Shape-Copy-3",
    fill: "#3C3C3B",
    transform: "translate(6.421487, 8.948421) rotate(-270.000000) translate(-6.421487, -8.948421) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4339958,10.8974925 C17.5868319,11.1954018 17.723542,11.5029478 17.8429737,11.8189781 C15.3603433,12.5708029 12.4854861,13 9.4212785,13 C6.3568652,13 3.48182779,12.5707452 0.99899695,11.8196166 C1.11901502,11.5029478 1.25572512,11.1954018 1.40856117,10.8974925 C3.75789303,11.5940117 6.49121661,12 9.4212785,12 C12.3037718,12 14.9958628,11.6070869 17.3190388,10.9317037 Z",
    id: "Combined-Shape-Copy",
    fill: "#3C3C3B",
    transform: "translate(9.421487, 11.948421) rotate(-180.000000) translate(-9.421487, -11.948421) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5098384,17.3699078 C11.340319,16.47589 13.1122096,15.6332614 15.8255101,14.8420221 C15.3237709,16.0566754 15.9962588,17.6148764 17.8429737,19.5166251 C20.6130462,22.369248 9.26411739,18.7109345 10.5098384,17.3699078 Z",
    id: "Path-2",
    fill: "#3C3C3B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnTranslate);
export default __webpack_public_path__ + "static/media/ICN_BTN_Translate.b17f1bd5a1a17a816a4f64e3da9663c4.svg";
export { ForwardRef as ReactComponent };